import './carousel.css'
import {Swiper, SwiperSlide} from 'swiper/react';
import {Pagination} from "swiper"
import "swiper/css"
import "swiper/css/pagination";

const Carousel = () => {

    return (
        <div className={'carousel'} id={'taomlarimiz'}>
            <div className="carousel_title">
                Таомларимиз
            </div>
            <div className="carousel_block">
                <Swiper
                    loop={true}
                    autoplay={true}
                    pagination={{
                        dynamicBullets: true,
                    }}
                    modules={[Pagination]}
                    className="mySwiper"

                    breakpoints={{
                        519: {
                            slidesPerView: 1,
                            spaceBetween: 20,
                        },
                        520: {
                            slidesPerView: 2,
                            spaceBetween: 20,
                        },
                        798: {
                            slidesPerView: 3,
                            spaceBetween: 30,
                        },
                        998: {
                            slidesPerView: 3,
                            spaceBetween: 40,
                        },
                        1080: {
                            slidesPerView: 4,
                            spaceBetween: 40,
                        }
                    }}>
                    <SwiperSlide className="carousel_items">
                        <img className="carousel_img"
                             src="https://failiem.lv/thumb_show.php?i=fwwzj9dse"
                             alt="img"/>
                        <div className="carousel_items_title">
                            Тирамуссу
                        </div>
                    </SwiperSlide>
                    <SwiperSlide className="carousel_items">
                        <img className="carousel_img"
                             src="https://failiem.lv/thumb_show.php?i=6w42ypgrw"
                             alt="img"/>
                        <div className="carousel_items_title">
                            Руккола Салат
                        </div>
                    </SwiperSlide>
                    <SwiperSlide className="carousel_items">
                        <img className="carousel_img" src="https://failiem.lv/thumb_show.php?i=yxqdntb2k" alt="img"/>
                        <div className="carousel_items_title">
                            СОФ Бургер
                        </div>
                    </SwiperSlide>
                    <SwiperSlide className="carousel_items">
                        <img className="carousel_img"
                             src="https://failiem.lv/thumb_show.php?i=ywtam8gda" alt="img"/>
                        <div className="carousel_items_title">
                            СОФ Шашлик
                        </div>
                    </SwiperSlide>
                    <SwiperSlide className="carousel_items">
                        <img className="carousel_img"
                             src="https://failiem.lv/thumb_show.php?i=exxfks7dy"
                             alt="img"/>
                        <div className="carousel_items_title">
                            Мевали Aссорти
                        </div>
                    </SwiperSlide>
                    <SwiperSlide className="carousel_items">
                        <img className="carousel_img"
                             src="https://failiem.lv/thumb_show.php?i=v82am524b"
                             alt="img"/>
                        <div className="carousel_items_title">
                            Қозон-Кабоб
                        </div>
                    </SwiperSlide>
                </Swiper>
            </div>
        </div>
    )
}
export default Carousel